import { Component } from 'react';
import Button from './Button';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Hook for real error logging (Sentry, Datadog, etc.)
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.error('ErrorBoundary caught an error:', error, info);
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  handleReload = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-gradient-to-b from-slate-50 via-white to-rose-50/30 p-6 dark:from-slate-950 dark:via-slate-900 dark:to-rose-950/15">
          <div className="card max-w-md p-8 text-center shadow-glow-lg">
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-red-200 to-rose-100 text-lg font-bold text-red-700 shadow-inner dark:from-red-900/50 dark:to-rose-900/30 dark:text-red-200">
              !
            </div>
            <h1 className="page-heading mb-2 text-lg">Something went wrong</h1>
            <p className="mb-6 text-sm text-slate-600 dark:text-slate-400">
              An unexpected error was caught by our safety net. Try again, or head back home.
            </p>
            <div className="flex justify-center gap-2">
              <Button variant="secondary" onClick={this.handleReset}>
                Try again
              </Button>
              <Button onClick={this.handleReload}>Go home</Button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
